import { Badge, Flex, Text } from '@frontend/legacy-components';

const LabelWithBadges = ({ labelText, badges }) => (
  <Flex align="center" gap={1}>
    <Text>{labelText}</Text>
    {badges.map(({ label, colorScheme }) => (
      <Badge key={label} colorScheme={colorScheme} size="sm">
        {label}
      </Badge>
    ))}
  </Flex>
);

const Label = ({ userGroup }) => {
  const { businessName, locator, hasCsr, isSandbox } = userGroup;
  const labelText = `${businessName} (${locator})`;

  const badges = [];
  if (isSandbox) badges.push({ label: 'Sandbox', colorScheme: 'warning' });
  if (hasCsr) badges.push({ label: 'CSR', colorScheme: 'info' });

  if (badges.length === 0) return <Text>{labelText}</Text>;
  return <LabelWithBadges labelText={labelText} badges={badges} />;
};
export default Label;
